<template>
  <div class="flex flex-col px-5">
    <div class="grow flex flex-col items-center justify-center">
      <h1 class="welcome__title mb-2">Exciting news!</h1>
      <h3 class="welcome__subtitle mb-[32px]" v-html="placeholderText"></h3>
      <div class="welcome__logo mb-4">
        <img :src="companyLogo" width="164" height="164" class="object-contain" alt="">
      </div>
      <div class="welcome__description" v-html="companyDescription">
      </div>
    </div>
    <div>
      <div class="text-center mb-4 text-base leading-[1.4em] text-darkGrey font-medium">
        Check out comics about American public works heroes
      </div>

      <a :href="placeholderLink" target="_blank" class="btn btn__secondary mb-[32px]">
        Read now
      </a>
      <div class="powered pb-[30px]">
        Powered by <img :src="logo" alt="fieldman">
      </div>

    </div>

  </div>
</template>
<script setup>
import logo from '@/assets/img/logo.svg';
const config = useRuntimeConfig();
const placeholderText = config.public.placeholderText || '';
const placeholderLink = config.public.placeholderLink || '';
const companyDescription = config.public.companyDescription || '';
const companyLogo = config.public.companyLogo || '';
</script>
<style lang="scss" scoped>
.welcome__title {
  font-weight: 700;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.01em;
  color: var(--dark-grey);
}

.welcome__subtitle {
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: var(--grey-700);
}

.welcome__description {

  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: var(--grey-700);
}


.powered {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-weight: 600;
  font-size: 12px;
  line-height: 117%;
  letter-spacing: -0.01em;
  color: #656E7D;
}
</style>
